<template>
  <div>
    <div :class="`adt_badge ${statusClassStyle}`">{{ statusDescription }}</div>
  </div>
</template>

<script>
export default {
  name: "ConsumerStatusBadge",

  props: ["helperObj", "status"],

  data() {
    return {
      statusDescription: "",
      statusClassStyle: "",
    };
  },

  mounted() {
    const filteredStatus = this.helperObj.filter(
      (status) => status.originalDescription === this.status,
    );
    this.statusDescription = filteredStatus[0].description;
    this.statusClassStyle = filteredStatus[0].class;
  },
};
</script>
